import { ofType } from "redux-observable";
import { from } from "rxjs";
import { switchMap } from "rxjs/operators";
import { actionModalClose } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
import { actionOngoingPurchaseCharacterHelpDeselect, TypeActionOngoingPurchaseInfo, } from "../actionOngoingPurchase";
export var epicOngoingPurchaseCharacterHelpClose = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionOngoingPurchaseInfo.CloseCharacterHelp), switchMap(function () {
        return from([
            actionModalClose(IdModal.CharacterHelp),
            actionOngoingPurchaseCharacterHelpDeselect(),
        ]);
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/ongoing-purchase/epics/epicOngoingPurchaseCharacterHelpClose.ts
// module id = 2033
// module chunks = 3